<common-modal
  *ngIf="isOpen"
  size="lg"
  [isOpen]="isOpen"
  (isOpenChange)="handleIsOpenChange($event)"
  position="center"
>
  <ng-container header>
    <h2 class="font-bold">{{ 'supportModal.title' | translate }}</h2>
  </ng-container>
  <ng-container body>
    <div>
      <span>
        {{ 'supportModal.text' | translate }}
      </span>

      <div *ngIf="showContactForm" class="my-4 p-2 bg-gray-900 rounded">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmitContact()">
          <common-text-input
            [label]="'supportModal.form.name' | translate"
            [control]="getFormControl('name')"
            property="name"
          ></common-text-input>
          <common-text-input
            [label]="'supportModal.form.email' | translate"
            [control]="getFormControl('email')"
            property="email"
          ></common-text-input>
          <common-text-input
            [label]="'supportModal.form.tgHandle' | translate"
            [control]="getFormControl('tgHandle')"
            property="tgHandle"
          ></common-text-input>
          <common-text-input
            [label]="'supportModal.form.info' | translate"
            [control]="getFormControl('info')"
            property="info"
          ></common-text-input>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <div *ngIf="!showContactForm" class="w-full flex justify-end gap-3">
      <common-empty-input
        [label]="'supportModal.dontShowAgain' | translate"
        [labelWidth]="6"
        class="flex-1"
      >
        <ng-container input>
          <div class="h-full flex items-center">
            <common-toggle-input
              class="flex mt-1"
              [value]="dontShowAgain"
              (valueChanged)="onDontShowAgainChange($event)"
            >
            </common-toggle-input>
          </div>
        </ng-container>
      </common-empty-input>
      <button (click)="onBookCall()" class="button mb-2 md:mb-0">
        {{ 'supportModal.button.bookCall' | translate }}
      </button>
      <button (click)="onShowContactForm()" class="button mb-2 md:mb-0">
        {{ 'supportModal.button.contact' | translate }}
      </button>
    </div>
    <div *ngIf="showContactForm" class="w-full flex flex-col justify-end">
      <div class="flex justify-end items-center gap-3">
        <a (click)="onBackToOptions()" class="cursor-pointer">{{
          'supportModal.form.back' | translate
        }}</a>
        <button (click)="onSubmitContact()" class="button mb-2 md:mb-0">
          {{ 'supportModal.form.send' | translate }}
        </button>
      </div>
      <div *ngIf="contactFormSent" class="mt-2 flex justify-end">
        <span class="text-green-300">{{
          'supportModal.form.sent' | translate
        }}</span>
      </div>
    </div>
  </ng-container>
</common-modal>
